/* eslint-disable react/no-array-index-key */
import { Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import React from 'react';

export type CSVData = any[];
export type CSVPreviewProps<Data extends object> = {
  data: Data[];
  onRowClicked?: (rowData: Data) => void;
  renderHeaderContent?: (rowIndex: number) => React.ReactNode;
};

export function CSVPreview<Data extends object>({
  data,
  renderHeaderContent,
}: CSVPreviewProps<Data>) {
  // Get the column headers
  const columns = data.length > 0 ? Object.keys(data[0]) : [];

  const renderHeader = (rowIndex: number) => {
    if (renderHeaderContent) {
      return renderHeaderContent(rowIndex);
    }
    return <>Row {rowIndex + 1}</>;
  };

  const renderValue = (value: any): string => {
    // we want to differentiate between null and undefined
    // and "null"
    if (value === null) {
      return 'js_null';
    }
    if (value === undefined) {
      return 'js_undefined';
    }

    if (value === '') {
      return 'empty_string';
    }

    if (value === 'null') {
      return 'string_null';
    }

    return String(value);
  };

  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Header</Th>
          {/* let caller render headers  */}
          {data.map((_, rowIndex) => (
            <Th key={rowIndex}>{renderHeader(rowIndex)}</Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>
        {/* Render each column as a row */}
        {columns.map((col, colIndex) => (
          <Tr key={colIndex}>
            <Td>{col}</Td>
            {data.map((row, rowIndex) => (
              // @ts-ignore
              <Td key={rowIndex}>{renderValue(row[col])}</Td>
            ))}
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
}
